const STORAGE_KEY = "kim-tour-visitor-tips";

export const getTipKey = ({ title = "", category = "" }) =>
  [category, title]
    .filter(Boolean)
    .join(":")
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/(^-|-$)/g, "");

export const getVisitorTips = (key) => {
  try {
    const allTips = JSON.parse(localStorage.getItem(STORAGE_KEY)) || {};
    return Array.isArray(allTips[key]) ? allTips[key] : [];
  } catch (error) {
    return [];
  }
};

export const saveVisitorTip = (key, tip) => {
  const allTips = JSON.parse(localStorage.getItem(STORAGE_KEY) || "{}");
  const nextTip = {
    id: Date.now().toString(),
    createdAt: new Date().toISOString(),
    ...tip,
  };

  const nextTips = [nextTip, ...(allTips[key] || [])].slice(0, 12);
  localStorage.setItem(
    STORAGE_KEY,
    JSON.stringify({
      ...allTips,
      [key]: nextTips,
    })
  );

  return nextTips;
};
